import React, { useState, useEffect } from "react"
import { useHistory } from "react-router"
// import backImage from "../../assets/images/back-icon.svg"

import { useSelector } from "react-redux"
import moment from "moment"
import { getDiscountPendingRasieRequests } from "core/services/api/mrdService"
import "../../../PendingRaiseRequests/PendingRaiseRequests.scss"
import Button from "components/Button"
import { MocUserRole } from "../../../../core/services/models/Enums"

function PendingDiscountList() {
  const history = useHistory()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)
  const userRole = useSelector((state: any) => state?.user?.role)




  //Pagination
  const [pages, setPages] = useState<any>(0)
  const [currPage, setCurrPage] = useState<any>(0)
  const [pageSize, setPageSize] = useState<any>(10)
  //Search For Patient Directory
  const [searchText, setSearchText] = useState<any>("")

  const [pendingApprovalRaiseRequests, setPendingApprovalRaiseRequests] = useState<any>([])
  const [data, setData] = useState<string[]>([])
  const [originalPendingApprovalRaiseRequests, setOriginalPendingApprovalRaiseRequests] = useState<any>([]);
  const [sortByTime, updateSortBy] = useState("DESC");

  useEffect(() => {
    //Pending Raise Requests for Approval API
    let url = ""
    if (searchText) {
      url = `discount-approvals/pagination?approverId=${userDetail?.id}&page=${currPage}&pageSize=${pageSize}&searchText=${searchText}`
    } else {
      url = `discount-approvals/pagination?approverId=${userDetail?.id}&page=${currPage}&pageSize=${pageSize}`
    }

    if (sortByTime) {
      url += `&sortBy=approvalRaisedTime&sortDirection=${sortByTime}`
    }

    getDiscountPendingRasieRequests(url)
      .then((res: any) => {
        const { data, totalPages, totalCount } = res
        console.log(data, "data coming from pagination");
        setPages(totalPages)
        // const temp = [...res]
        // data?.sort((a: any, b: any) => {
        //   return sortByTime === "asc" ?
        //     a?.approvalRaisedTime > b?.approvalRaisedTime ? 1 : -1
        //     : a?.approvalRaisedTime < b?.approvalRaisedTime ? 1 : -1
        // })
        setPendingApprovalRaiseRequests(data);
        setOriginalPendingApprovalRaiseRequests(data);
        setData(data);

      })
      .catch((err: any) => console.log(err?.message))
  }, [pageSize, currPage, searchText, sortByTime])

  useEffect(() => {
    if (sortByTime) {
      const temp = [...pendingApprovalRaiseRequests]
      // temp?.sort((a: any, b: any) => {
      //   return sortByTime === "asc" ?
      //     a?.approvalRaisedTime > b?.approvalRaisedTime ? 1 : -1
      //     : a?.approvalRaisedTime < b?.approvalRaisedTime ? 1 : -1
      // })
      setPendingApprovalRaiseRequests(temp);
      setData(temp);
    }
  }, [sortByTime])

  const handleEdit = async (id: any, patientId: any, recordId: any) => {

    // history.push(`/addNewReferrals`, path)
    history.push({
      pathname: "/mrdApprovalRequest",
      state: {
        selected: recordId
      },
    })
  }

  const handleSortOption = (e: any) => {
    updateSortBy(sortByTime === "ASC" ? "DESC" : "ASC")
  }



  const handleSearch = (searchQuery: any) => {
    console.log(searchQuery, "search");
    console.log(pendingApprovalRaiseRequests, "pending Approval Raise Request");

    if (!searchQuery) {
      // If searchQuery is empty, reset to the original list
      setPendingApprovalRaiseRequests(originalPendingApprovalRaiseRequests);
    } else {
      const filteredRequests = originalPendingApprovalRaiseRequests.filter(
        (request: any) => {
          const patientNameMatches = request.patientName.toLowerCase().includes(searchQuery.toLowerCase());
          const patientIdMatches = request.patientMocId.toLowerCase().includes(searchQuery.toLowerCase());

          return patientNameMatches || patientIdMatches;
        }
      );

      console.log(filteredRequests, "filtered Requests");
      setPendingApprovalRaiseRequests(filteredRequests);
    }
  };



  const handleViewAll = async (id: any, patientId: any, recordId: any, invoiceId: any, type: any) => {
    if (userRole === MocUserRole?.CONSULTANT || userRole === MocUserRole?.CENTER_ADMIN) {

      if (type == "consultant") {
        history.push({
          pathname: "/consultantApprovalRequest",
          state: {
            idValue: id,
            patientIdValue: patientId,
            recordIdValue: recordId,
          },
        })
      }
      if (type == "consultantDiscount") {
        history.push({
          pathname: `/discountApprovalRequest/${id}/${invoiceId}`,
          state: {
            idValue: id,
            invoiceId: invoiceId,
          },
        })

      }

    }

  }


  return (
    <div className="approval-request-wrapper">
      <div className="approval-request-section">
        {/* <div className="approval-heading-container">
          <div
            className="approval-back-image"
            onClick={() => {
              history.push("/")
            }}
          >
            <img
              src="../../assets/images/back-icon.svg"
              height={"60px"}
              width={"60px"}
              alt="back button"
              className="back_button"

            />
          </div>
          <div className="approval-request-text">Billing</div>
        </div> */}
        <section className="section-two-container">
          <div className="search-dropdown-wrapper">
            <div className="row pl-42 pt-17px">
              <div className="col-md-6 col-lg-6">
                <span>
                  <input
                    className="inputGlobalSearch"
                    placeholder="Search"
                    onChange={(e) => {
                      //handleSearch(e.target.value)
                      setSearchText(e.target.value)
                      setCurrPage(0)
                    }}
                  />
                  <img
                    src="assets/images/searchIcon.svg"
                    alt=""
                    style={{
                      marginLeft: "-50px",
                      width: "26px",
                      height: "26px",
                    }}
                  />
                </span>
              </div>
              <div className="col-md-1 col-lg-1">

                <Button
                  text="Sort By Time"
                  outline={true}
                  onClick={handleSortOption}
                  id="sort-by-time"
                />
              </div>
            </div>
          </div>
          {pendingApprovalRaiseRequests?.map((item: any) => {
            return (
              <div className="pending-appointment-request-wrapper">
                <div className="row patientid">
                  <div className="col-md-1 col-lg-1">
                    <label className="patient-id-container">Patient ID:</label>
                  </div>
                  <div className="col-md-2 col-lg-2 p-0 patientidvalue">
                    {item?.patientMocId}
                  </div>
                  <div className="col-md-9 col-lg-9 editSection">
                    <div style={{ paddingLeft: "20px" }}>
                      <img
                        // className={globalStyles.pointer}
                        src={"../../../assets/images/CRedit.svg"}
                        alt="edit"
                        width={24}
                        height={24}
                        className="cursor-pointer"
                        onClick={() =>
                          handleViewAll(item?.id, item?.approverId, item?.recordId, item?.invoiceId, "consultantDiscount")
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row pt-28 patientdetails">
                  <div className="col-12 d-flex">
                    <div className="col-4 pl-47 sectionone">
                      <div className="row">
                        <div className="col-12 d-flex pt-24">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Patient name:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              &nbsp;{item?.patientName}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Requested By:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.approvee}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 pl-47 sectiontwo">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Date:
                            </label>
                          </div>


                          <div className="col-8">
                            <label className="values-container-field">
                              {/* {item.approvalRaisedTime?.slice(0, 10)}
                               */}
                              {item?.approvalRaisedTime
                                ? moment(item?.approvalRaisedTime).format(
                                  "DD-MM-yyyy"
                                )
                                : ""}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Time:
                            </label>
                          </div>


                          <div className="col-8">
                            <label className="values-container-field">
                              {/* {item.approvalRaisedTime?.slice(0, 10)}
                               */}
                              {item?.approvalRaisedTime
                                ? moment(item?.approvalRaisedTime).format("HH:mm:ss a")
                                : ""}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-4 pl-47 sectionthree">
                      <div className="row">
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Contact Number:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.patientContactNumber}
                            </label>
                          </div>
                        </div>
                        <div className="col-12 d-flex">
                          <div className="col-4">
                            <label className="patient-id-container">
                              Email:
                            </label>
                          </div>

                          <div className="col-8">
                            <label className="values-container-field">
                              {item?.patientEmail}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row complaintsection">
                  <div className="col-1">
                    <label className="patient-id-container">Remarks:</label>
                  </div>
                  <div className="col-11 complaintreason">
                    <label className="values-container-field">
                      {item?.reason}
                    </label>
                  </div>
                  <div className="col-1">
                    <label className="patient-id-container">Discount%:</label>
                  </div>
                  <div className="col-11 complaintreason">
                    <label className="values-container-field">
                      {item?.discount}
                    </label>
                  </div>
                </div>
                <div className="row statussection">
                  <div className="col-1">
                    <div className="row">
                      <label className="patient-id-container">Status:</label>
                      {/* <label className="patient-id-container">Reason:</label> */}
                    </div>
                  </div>
                  <div className="col-11 statusdetails">
                    <div className="row">
                      <label className="values-container-field">{item?.approvalStatus}</label>
                      {/* <label className="values-container-field">{item.reason}</label> */}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
        </section>
        {/* Pagination */}

        {
          data && data?.length > 0 ? (
            <div
              style={{ marginTop: "20px" }} className="pagination-footer"
            >
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(0);
                }}
                disabled={currPage === 0}
              >
                {"First"}
              </button>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(currPage - 1);
                }}
                disabled={currPage === 0}
              >
                {"Previous"}
              </button>
              <span className="pagination-text">
                Page{" "}
                <strong>
                  {currPage + 1} of {pages}
                </strong>
              </span>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(currPage + 1);
                }}
                disabled={currPage === pages - 1}
              >
                {"Next"}
              </button>
              <button
                className="pagination-button"
                onClick={() => {
                  setCurrPage(pages - 1);
                }}
                disabled={currPage === pages - 1}
              >
                {"Last"}
              </button>
              <select
                className="pagination-select"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrPage(0);
                }}
              >
                {[10, 15, 20, 25, 50].map((pageSize) => (
                  <option key={pageSize} value={pageSize}>
                    {pageSize}
                  </option>
                ))}
              </select>
            </div>
          ) : null
        }
      </div>
    </div>
  )
}

export default PendingDiscountList
